import { Outlet } from "react-router-dom";
import ProblemSidebar from "../../components/problem-sidebar";
import useBackButton from "../../hooks/useBackButton";
import { useProblem } from "../../contexts/problem-context";

export default function ProblemContainer() {
  const [, problemDispatch] = useProblem();
  const backPressed = () => {
    problemDispatch({
      type: "truncate preferences",
    });
  };

  const isBackPressed = useBackButton(backPressed);
  return (
    <div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-12 my-16">
        <ProblemSidebar />
        <div className="col-span-12 lg:col-span-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
